import { createApi } from "@reduxjs/toolkit/query/react";
import { tokenQuery } from "./tokenQuery";

const toCamelCase = (str) => str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

const flattenProfile = (response) => {
    if (!response) return response;
    const { user_profile, ...rest } = response;
    if (user_profile) {
        const flat = {};
        for (const [key, val] of Object.entries(user_profile)) {
            flat[toCamelCase(key)] = val;
        }
        return { ...rest, ...flat, user_profile };
    }
    return response;
};

const profileAPI = createApi({
    reducerPath: "profileAPI",
    baseQuery: tokenQuery,
    endpoints: (builder) => ({
        getProfileDetails: builder.mutation({
            query: () => {
                return {
                    url: 'staff/profile',
                    method: "GET",
                };
            },
            transformResponse: (response) => flattenProfile(response)
        }),
        editProfileDetails: builder.mutation({
            query: ({body}) => {
                const apiUrl = `staff/auth/update/profile/details`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body: body
                };
            },
            transformResponse: (response) => response
        }),
        getImageUploadURL: builder.mutation({
            query: ({staffId, extension, type}) => {
                let url = `staff/auth/upload?extension=${extension}&uploadType=${type}`;
                if(staffId){
                    url += `&staffId=${staffId}`
                }
                return { url, method: "GET" };
            },
            transformResponse: (response) => response,
        }),
    }),
});

export const { 
    useGetProfileDetailsMutation,
    useEditProfileDetailsMutation,
    useGetImageUploadURLMutation
} = profileAPI;

export default profileAPI;